import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SubscriptionPlanFormComponent } from './subscription-plan-form.component';
import { RnplCommonModule, UIComponentsModule } from 'common/src/modules';

@NgModule({
  declarations: [
    SubscriptionPlanFormComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RnplCommonModule,
    UIComponentsModule,
    TranslateModule
  ],
  exports: [
    SubscriptionPlanFormComponent,
  ],
})
export class SubscriptionPlanFormModule { }
